<template>
  <div class="NewsDetails">
    <banner img="../assets/img/bgtop.jpg" />
    <div class="NewsDetails-product">
      <div class="NewsDetails-product-content">
		<p class="product-title">广东卫宁2023启动会</p>
        <p>四季初始，岁月向荣。2023年2月19日，广东卫宁2023启动会于佛山成功举办。本次启动会以“迎势·加速”为主题，总结了广东卫宁2022年的工作业绩，明确2023年的战略目标和工作重点，表彰了2022年度优秀员工与优秀团队。</p>
        <img v-lazy="require('../assets/img/1.jpg')" alt />
		<p>在疫情常态化管理的新形势下，医疗机构通过数字技术推动高质量发展的需求会更加迫切，“加速”将成为未来3至5年的关键词，面对未来快速变化的发展形势与要求，广东卫宁按照卫宁健康集团的统一布署，坚持推进“1+X”战略框架，以积极进取的卫宁精神“迎势，加速”。</p>
		<img v-lazy="require('@/assets/img/2.jpg')" alt />
		<p>广东卫宁总经理韩周礼对2022年度的经营工作情况进行了回顾总结，在疫情的背景下，公司能在2022年度取得合同业绩超额完成预期目标，连续几年保持持续稳健的发展，离不开全体员工共同努力拼博，是各部门有效协同的成果。同时也指出公司存在问题、进行原因分析以及提出应对措施，要求各部门提质增效。展望未来，基于现时的市场环境与机会分析，公司重组新架构。韩总制定公司2023年的战略目标和工作部署，重点加强梯队人才建设及完善培训体系，培养更强大的项目交付团队，要求公司全体员工提高自我提升意识，与公司共同进步，共同发展。</p>
		<img v-lazy="require('@/assets/img/3.jpg')" alt />
		<p>广东卫宁常务副总李世杰介绍2023年交付体系绩效考核框架，从交付体系管理矩阵展开，围绕考核内容，提出了常态化考核的要求，并就奖金核算和奖金分配方案作出详细讲解，要求全体交付团队要有积极肯干的工作态度，保持工作热情和责任感，同时加强业务系统的学习，提高交付能力，激励大家提升自我价值的同时，获取更高回报。</p>
		<img v-lazy="require('@/assets/img/4.jpg')" alt />
		<p>广东卫宁副总经理林廷科对2022年销售团队的业绩工作进行分析总结，销售团队在2022年度取得了较好的业绩，每一个项目的落地，都离不开团队中每位成员的齐心协力和辛勤付出。展望2023，基于国家的政策支持和公司的经营工作目标，销售团队制定了明确的业绩目标和业务策略。全体斗志昂扬，齐心向更高的目标努力。</p>
		<img v-lazy="require('@/assets/img/5.jpg')" alt />
		<p>广东卫宁副总经理陈碧辉对交付团队在2022年所取得的成绩及不足之处进行了分析总结。交付团队在2022年度按计划完成了重点项目的上线验收工作，成功伴着艰辛，喜悦伴着汗水，团队一直秉持着务实努力的风格，获得用户的认可。2023年交付中心重新出发，以新的架构，重新整合资源，完善培训体系，提升交付团队的项目管理能力和实施能力，提升服务效率，迎势加速。</p>
		<img v-lazy="require('@/assets/img/6.jpg')" alt />
		<p>广东卫宁财务经理李海玉对公司财务报销制度进行讲解，对于常见的报销问题、注意事项以及报销要求等分别说明，并对财务报销系统填报基本要求及流程进度的查阅进行培训。</p>
		<img v-lazy="require('@/assets/img/7.jpg')" alt />
		<img v-lazy="require('@/assets/img/8.jpg')" alt />
		<img v-lazy="require('@/assets/img/9.jpg')" alt />
		<p>会议表彰了2022年度广东卫宁11位优秀员工与2个优秀团队，举行了颁奖仪式，优秀员工奖项包括：最佳销售奖、最佳影响奖、最佳老客户经营奖、最佳实施奖、最佳进步奖、优秀项目经理奖、优秀新人奖。肇庆高新技术产业开发区人民医院项目组荣获快速切换奖，平台技术部被评为优秀部门。</p>
		<p>会议期间，公司组织项目经理进行工作述职和高阶培训，工作述职中分析了项目工作业绩和存在问题，规划了2023年项目工作计划。参会领导班子分别点评并给出解决方案和工作展望。高阶培训由副总兼交付中心总经理陈碧辉对项目经理进行项目管理培训及经验分享，传授相关项目汇报、项目协调、项目推进的技巧，以及应对突发事件的处理方法。</p>
		<p>项目经理进行了一场别开生面的行动学习，围绕几个重点主题，以个人为单位，参与话题辩论，参会众人就项目管理中可能发生的问题或突发事件作为主要论点，进行头脑风暴，各抒已见、集思广益，学习场面热情高涨、积极发言气氛活跃，大家受益颇丰。</p>
		<img v-lazy="require('@/assets/img/10.jpg')" alt />
		<p>2023，迎势加速，新的速度带来新的力量。让我们执着梦想，巅峰领跃！</p>
	  </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  name: "NewsDetails",
  components: {
    Banner
  },
  data() {
    return {
      pid: 0,
      news: []
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.NewsDetails {
  width: 100%;
  height: 100%;
  //overflow: hidden;
  background-color: #14679f;
  &-product {
    width: 1240px;
    margin: 0 auto;
    background-color: #fff;
    border: 1px solid red;
    &-content {
      width: 760px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 50px 0;
      img {
        width: 100%;
        //height: 500px;
      }
      .product-title {
        font-size: 25px;
        color: #e13834;
        padding: 20px 0;
      }
      .product-content {
        font-size: 17px;
        font-weight: bolder;
        padding: 20px 0;
      }
    }
  }
}
p {
	text-indent:2em;
}
img {
	margin: 1rem 0rem;
}
</style>